import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import styles from './selectable-list.css';
export function SelectableListGroup(props) {
    const { className, groupName, children } = props;
    return (_jsxs("div", { ...assignTestId('selectable-list-group', props), className: classNames(styles.group, className), children: [_jsx("header", { className: styles.groupName, children: groupName }), _jsx("div", { className: styles.groupContent, children: children })] }));
}
